import React from "react"
import { Link } from "gatsby"
import Helmet from "react-helmet"
import Layout from "../../layout/base"
import SEO from "../../components/seo"
import Cell from "../../components/cell"
import Stage from "../../components/stage"
import Breadcrumb from "../../components/breadcrumb"
import MorphingBubble from "../../components/morphingbubble"
import Accordion from "../../components/accordion"
// import JSON from "../../../data/about-our-purpose.json"
import Readmore from "../../components/readmore"
import { Parallax } from "react-parallax"
import MorphingShapeWrapper from "../../components/morphingshapewrapper"

const accordionItems = [
  {
    title: "How are Miltenyi's CAR-T therapies manufactured?",
    content:
      "All investigational therapies are manufactured on the CliniMACS Prodigy® platform, an automated, closed system designed to reduce variability and ensure GMP-compliant processes.",
    contentJSON:
      "All investigational therapies are manufactured on the CliniMACS Prodigy platform, an automated, closed system designed to reduce variability and ensure GMP-compliant processes.",
  },
]

// Create FAQ JSON-LD schema from accordionItems
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: accordionItems
    .filter(item => item.title && item.content)
    .map(item => ({
      "@type": "Question",
      name: item.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.contentJSON,
      },
    })),
}

const schemaAsString = JSON.stringify(faqSchema, null, 2)

const IndexPage = () => (
  <Layout site="manufacturingtechnology" footer="">
    <Helmet>
      <script type="application/ld+json">{schemaAsString}</script>
    </Helmet>
    <SEO
      title="Manufacturing technology | Miltenyi Biomedicine GmbH"
      description="Our therapeutic candidates are manufactured on the CliniMACS Prodigy® platform an automated, closed system that has pioneered scalable cell therapy manufacturing"
    />
    <Stage
      className="mb-3 stage--bg3 stage--manufacturingtechnology"
      site="manufacturingtechnology"
    >
      <div
        className="d-block d-md-none"
        style={{
          width: "500px",
          height: "500px",
          top: "-180%",
          right: "-15%",
          position: "absolute",
        }}
      >
        <Cell
          style={{}}
          settings={{
            duration: "50000",
            translateX: "-220px",
            translateY: "10px",
          }}
        >
          <img
            src={
              require("../../images/elements/HP_killing_cancer_situation.svg")
                .default
            }
            alt="Cancer Separate"
          />
        </Cell>
      </div>

      <div
        className="d-none d-md-block d-lg-none"
        style={{
          width: "400px",
          height: "400px",
          top: "-300%",
          right: "-15%",
          position: "absolute",
        }}
      >
        <Cell
          style={{}}
          settings={{
            duration: "50000",
            translateX: "-120px",
            translateY: "100px",
          }}
        >
          <img
            src={
              require("../../images/elements/HP_killing_cancer_situation.svg")
                .default
            }
            alt="Cancer Separate"
          />
        </Cell>
      </div>

      <div
        className="d-none d-lg-block d-xl-none"
        style={{
          width: "400px",
          height: "400px",
          top: "-400%",
          right: "-25%",
          position: "absolute",
        }}
      >
        <Cell
          style={{}}
          settings={{
            duration: "50000",
            translateX: "-120px",
            translateY: "100px",
          }}
        >
          <img
            src={
              require("../../images/elements/HP_killing_cancer_situation.svg")
                .default
            }
            alt="Cancer Separate"
          />
        </Cell>
      </div>
      <div
        className="d-none d-xl-block"
        style={{
          width: "800px",
          height: "800px",
          top: "-60%",
          right: "-35%",
          position: "absolute",
        }}
      >
        <Cell
          style={{}}
          settings={{
            duration: "50000",
            translateX: "-120px",
            translateY: "100px",
          }}
        >
          <img
            src={
              require("../../images/elements/HP_killing_cancer_situation.svg")
                .default
            }
            alt="Cancer Separate"
          />
        </Cell>
      </div>
    </Stage>

    <div className="container ">
      <div className="row ">
        <div className="col-12">
          <div className="career-detail__breadcrumb mt-5 mt-lg-0">
            <Breadcrumb
              data={[
                { text: "Home", link: "/" },
                {
                  text: "Our technology",
                },
                {
                  text: "Manufacturing technology",
                },
              ]}
            />
          </div>
        </div>

        <div className="col-12 mt-3 ">
          <h1 className="util-h1 ">Manufacturing technology</h1>
        </div>
      </div>
    </div>

    <div className="container util-content-mb-1 ">
      <div className="d-flex_ row flex-column-reverse flex-lg-row">
        <div className="col-12 col-lg-6 position-relative">
          <div className="util-zindex position-relative  text-lg-left">
            <p className="util-text-1">
              Our therapeutic candidates are manufactured on the CliniMACS
              Prodigy® platform an automated, closed system that has pioneered
              scalable cell therapy manufacturing. This means:
            </p>
            <p className="util-text-1">
              <strong>Consistency:</strong> reduced operator variability for
              reliable therapeutic products
            </p>
            <p className="util-text-1">
              <strong>Scalability:</strong> capacity to expand supply as needs
              grow
            </p>
            <p className="util-text-1">
              <strong>Quality assurance:</strong> processes designed to meet
              global GMP standards
            </p>
            <p className="util-text-1">
              <strong>Efficiency:</strong> supports faster scale up and helps
              optimize vein-to-vein time
            </p>
            <p className="util-text-1">
              By manufacturing our therapies on Miltenyi Biotec's CliniMACS
              Prodigy®, Miltenyi Biomedicine ensures robust process integrity
              and the infrastructure to deliver cell therapies to more patients
              reliably.
            </p>
            <Link
              to="/our-technology/manufacturing-network/"
              className="btn btn--primary btn--bg-gray mt-4"
            >
              Explore our technology
            </Link>
          </div>
          <Cell
            className="d-none d-xl-block"
            style={{
              width: "100px",
              bottom: "-10%",
              left: "85%",
            }}
            settings={{
              duration: 80000,
              translateX: "350px",
              translateY: "-80px",
            }}
          >
            <img
              className="lazyload"
              data-src={require("../../images/elements/antibody-1.svg").default}
              alt="Antibody 1"
            />
          </Cell>
          <Cell
            style={{
              width: "50px",
              bottom: "0",
              right: "40%",
            }}
            settings={{
              duration: 100000,
              translateX: "180px",
              translateY: "120px",
            }}
          >
            <img
              className="lazyload"
              data-src={require("../../images/elements/antibody-2.svg").default}
              alt="Antibody 2!"
            />
          </Cell>
          <Cell
            className="d-none d-xxl-block"
            style={{
              width: "300px",
              top: "-20%",
              left: "-80%",
            }}
          >
            <img
              className="lazyload"
              data-src={
                require("../../images/elements/green-bubble-1.svg").default
              }
              alt="Green Bubble 1"
            />
          </Cell>
          <Cell
            className="d-none d-xl-block d-xxl-none"
            style={{
              width: "300px",
              top: "0%",
              left: "-75%",
            }}
          >
            <img
              className="lazyload"
              data-src={
                require("../../images/elements/green-bubble-1.svg").default
              }
              alt="Green Bubble 1"
            />
          </Cell>
        </div>
        <div className="col-12 col-lg-6 mb-4 mb-sm-0">
          <MorphingBubble id="cellfactory4" />
        </div>
      </div>
    </div>

    <div className="container util-content-mb-2 ">
      <div className="row pb-5">
        <div className="col-12">
          <Accordion
            className="accordion accordion--large accordion--tertiary"
            allowMultipleOpen={true}
          >
            {accordionItems.map((section, i) => {
              return (
                <div
                  key={i}
                  label={section.title}
                  isOpen={true}
                  id={`accordion-${i}`}
                >
                  {section.content}
                </div>
              )
            })}
          </Accordion>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
